import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Pabrik.css";
import axios from "axios";

const Pabrik = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const [kapasitas, setKapasitas] = useState("Klik untuk Update Kapasitas"); 
  const [isLoading, setIsLoading] = useState(false);
  const [tanggal, setTanggal] = useState("");

  const handleProfileClick = () => {
    navigate("/profile");
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return "-";
    return new Intl.NumberFormat("id-ID").format(value);
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  const handleKapasitas = () => {
    updateKapasitas();
  };

  const updateKapasitas = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/update_kapasitas_per_jam",
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data;
      if (response.status === 200) {
        const kapasitasFormatted = (
          parseFloat(result.kapasitas_terbaru) || 0
        ).toFixed(2);
        setKapasitas(kapasitasFormatted);
      } else {
        console.error(result.error);
      }
    } catch (error) {
      console.error("Error updating kapasitas:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span
            id="user-role"
            onClick={handleProfileClick}
            style={{ cursor: "pointer" }}
          >
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/pabrikt")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrikt" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrikt" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Planting" /> Transaksi
            </div>
            <div
              onClick={() => navigate("/pabrikh")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/pabrikh" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/pabrikh" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/packaging.png" alt="Harvest" /> Hasil
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <h1>Beranda</h1>
          <div className="divider"></div>

          {/* Dashboard Cards */}
          <div className="row g-4 dashboard-cards">
            
            {/* Kapasitas Pabrik */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="dashboard-card danger" onClick={handleKapasitas}>
                <div className="card-icon">
                  <img src="/static/packaging.png" alt="Kapasitas" />
                </div>
                <div className="card-content" style={{ minWidth: 0, flex: 1 }}>
                  {/* Menggunakan h4 dengan ukuran fleksibel agar teks panjang seperti 'Klik untuk Update Kapasitas' tidak meluber keluar */}
                  <h4 style={{ fontSize: isNaN(kapasitas) ? "16px" : "32px", fontWeight: "700", margin: 0, wordBreak: "break-word" }}>
                    {isLoading ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      isNaN(kapasitas) ? kapasitas : formatNumber(kapasitas)
                    )}
                  </h4>
                  <p>Kapasitas Pabrik</p>
                </div>
              </div>
            </div>

            {/* Harga Sawit */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div
                className="dashboard-card success"
                onClick={() => navigate("/sawitPa")}
              >
                <div className="card-icon">
                  <img src="/static/sell_8087698.png" alt="Harga Sawit" />
                </div>
                <div className="card-content">
                  <h2>Rp. ---</h2>
                  <p>Harga Sawit Hari Ini</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Pabrik;